import { Button, Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, makeStyles, Paper, TextField } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { withStyles } from "@material-ui/styles";
import clsx from 'clsx';
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addAction, addMenu, addSubMenu, getConfigActionList } from "redux/modules/configActionSlice";

export const StyleCheckbox = withStyles((theme) => ({
  root: {
    borderRadius: 6,
    color: "#8898aa",
    "&$checked": {
      color: theme.palette.success.main,
    },
  },
  checked: {},
}))(Checkbox);

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpButton: {
    marginTop: 30,
    textAlign: 'right'
  },
  buttonSave: {
    marginLeft: 5,
    width: 120
  },
  menuRow: {
    fontWeight: "500", padding: "10px 15px", borderBottom: "1px solid lightgray", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", position: "relative"
  },
  subMenu: {
    marginLeft: "15px", cursor: "pointer", backgroundColor: "whitesmoke", display: "flex", justifyContent: "space-between", alignItems: "center"
  },
  listItem: {
    border: '1px solid lightgray',
    cursor: 'pointer',
  },
  listItemText: {

    '& span, & svg': {
      fontWeight: 500,
      fontSize: 13,
    }
  },
  actionSelected: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff'
  },
  roleCheckbox: {
    height: 20
  },
  warpDialog: {

    padding: "30px", minWidth: "350px", minHeight: "200px"
  },
  warpButtonDialogSave: {
    display: 'flex'
  },
  buttonDialogSave: {
    width: '100%',
    margin: '15px 5px'
  },
  textDialog: {
    width: '100%',
  }
}));
function ConfigDialog(props) {
  const classes = useStyles();
  const { onClose, selectedValue, open, actionName } = props;
  const [text, setText] = useState();
  const [isCustom, setIsCustom] = useState(false);
  useEffect(() => {
    setText(selectedValue.text);
    setIsCustom(selectedValue?.data?.isCustom);
  }, [selectedValue]);

  const handleClose = () => {
    onClose(null);
  };

  const handleListItemClick = () => {
    onClose({
      data: selectedValue,
      text,
      isCustom: isCustom
    });
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} maxWidth="xs" className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title">Name</DialogTitle>
      <DialogContent>
        <div>
          <TextField defaultValue={text} variant="outlined"
            className={classes.textDialog}
            onChange={(event) => setText(event.target.value)}
          />

        </div>

        {
          (actionName == 'addAction' || actionName == 'editAction') &&
          <div>
            <FormControlLabel
              control={
                <StyleCheckbox
                  name="canAccess"
                  checked={isCustom}
                  onChange={(event) => setIsCustom(event.target.checked)}
                />
              }
              label="Director can access."
            />
          </div>
        }

        <div className={classes.warpButtonDialogSave}>
          <Button variant="outlined" size="medium" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
            Close
          </Button>
          <Button variant="contained" size="medium" color="primary" onClick={() => handleListItemClick()} className={classes.buttonDialogSave}>
            Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

ConfigDialog.propTypes = {
  // onClose: PropTypes.func.isRequired,
  // open: PropTypes.bool.isRequired,
  // selectedValue: PropTypes.string.isRequired,
};



function ManageActionPage() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState('');
  const [actionName, setactionName] = React.useState('');
  const [isCustom, setIsCustom] = useState(false);

  const [state, setAction] = useState({
    actions: [],
  });


  useEffect(() => {
    dispatch(getConfigActionList());
  }, [dispatch]);


  const { list } = useSelector((state) => state.configAction);


  const handleClickOpen = (actionName, text, data) => {

    setactionName(actionName);
    setSelectedValue({ data: data, text: text });
    setOpen(true);
  };


  const handleClickRemove = (actionName, data) => {
    if (!window.confirm('Do you want to remove this item?')) { return; }

    setactionName(actionName);

    if (actionName === 'removeCate') {
      removeCate(data);
    }
    else if (actionName === 'removeSub') {
      removeSub(data);
    }
    else if (actionName === 'removeAction') {
      removeAction(data);
    }
  };

  const handleClose = (value) => {

    setOpen(false);


    if (value) {
      if (actionName === 'addCate') {
        addCate(value);
      }
      else if (actionName === 'addSub') {
        addSub(value);
      }
      else if (actionName === 'editCate') {
        editCate(value);
      }
      else if (actionName === 'addAction') {
        addActionMenu(value);
      }
      else if (actionName === 'editSub') {
        editSubCate(value);
      }
      else if (actionName === 'editAction') {
        editAction(value);
      }
    }

  };





  const handleOnSelectSubMenu = (actionMenu) => {
    setAction({ actions: actionMenu })
  }

  const addCate = async (cate) => {
    const body = {
      menuNo: '',
      menuName: cate.text,
      status: 'Y',
    };

    await dispatch(addMenu(body));
    await dispatch(getConfigActionList());


  }

  const editCate = async (cate) => {
    const body = {
      menuNo: cate.data.data.menuNo,
      menuName: cate.text,
      status: 'Y',
    };
    await dispatch(addMenu(body));
    await dispatch(getConfigActionList());

  }

  const removeCate = async (cate) => {
    const body = {
      menuNo: cate.menuNo,
      menuName: cate.menuName,
      status: 'N',
    };

    await dispatch(addMenu(body));
    await dispatch(getConfigActionList());

  }


  const addSub = async (data) => {

    const body = {
      subMenuNo: '',
      menuNo: data.data.data.menuNo,
      subMenuName: data.text,
      status: 'Y',
    };

    await dispatch(addSubMenu(body));
    await dispatch(getConfigActionList());



  }

  const editSubCate = async (data) => {
    const body = {
      subMenuNo: data.data.data.subMenuNo,
      menuNo: data.data.data.menuNo,
      subMenuName: data.text,
      status: 'Y',
    };
    await dispatch(addSubMenu(body));
    await dispatch(getConfigActionList());

  }

  const removeSub = async (data) => {
    const body = {
      subMenuNo: data.subMenuNo,
      menuNo: data.menuNo,
      subMenuName: data.subMenuName,
      status: 'N',
    };
    await dispatch(addSubMenu(body));
    await dispatch(getConfigActionList());

  }


  const addActionMenu = async (data) => {
    const body = {
      menuNo: data.data.data.menuNo,
      subMenuNo: data.data.data.subMenuNo,
      actionNo: '',
      actionName: data.text,
      status: 'Y',
      isCustom: data.isCustom
    };
    await dispatch(addAction(body));
    const res = await dispatch(getConfigActionList());

    const menu = res.payload.find(x => x.menuNo === data.data.data.menuNo);
    if (menu) {
      const sub = menu.subMenu.find(x => x.subMenuNo === data.data.data.subMenuNo)
      if (sub) {
        setAction({ actions: sub.actionMenu })
      }
    }

  }

  const editAction = async (data) => {
    const body = {
      menuNo: data.data.data.menuNo,
      subMenuNo: data.data.data.subMenuNo,
      actionNo: data.data.data.actionNo,
      actionName: data.text,
      status: 'Y',
      isCustom: data.isCustom
    };
    await dispatch(addAction(body));
    const res = await dispatch(getConfigActionList());

    const menu = res.payload.find(x => x.menuNo === data.data.data.menuNo);
    if (menu) {
      const sub = menu.subMenu.find(x => x.subMenuNo === data.data.data.subMenuNo)
      if (sub) {
        setAction({ actions: sub.actionMenu })
      }
    }

  }

  const removeAction = async (data) => {
    const body = {
      menuNo: data.menuNo,
      subMenuNo: data.subMenuNo,
      actionNo: data.actionNo,
      actionName: data.actionName,
      status: 'N',
      isCustom: data.isCustom
    };
    await dispatch(addAction(body));
    const res = await dispatch(getConfigActionList());

    const menu = res.payload.find(x => x.menuNo === data.menuNo);
    if (menu) {
      const sub = menu.subMenu.find(x => x.subMenuNo === data.subMenuNo)
      if (sub) {
        setAction({ actions: sub.actionMenu })
      }
    }

  }


  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="Manage Action" />
      <ConfigDialog selectedValue={selectedValue} open={open} onClose={handleClose} actionName={actionName} />
      <div className={classes.warpButton}>
        <Button variant="contained" size="medium" color="primary" className={classes.buttonSave}>
          Upload
        </Button>
        <Button variant="contained" size="medium" color="primary" className={classes.buttonSave}>
          Download
        </Button>
      </div>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <h4>Category</h4>
          <div>
            {
              list.map(l => (
                <div key={l.menuNo}>
                  <div className={classes.menuRow}>

                    <div>
                      {l.menuName}
                    </div>
                    <ListItemSecondaryAction>
                      <IconButton size="medium" edge="end" aria-label="add" onClick={() => handleClickOpen('addSub', '', l)}>
                        <AddIcon color="primary" />
                      </IconButton>
                      <IconButton size="medium" edge="end" aria-label="edit" onClick={() => handleClickOpen('editCate', l.menuName, l)}>
                        <EditIcon color="primary" />
                      </IconButton>
                      <IconButton size="medium" edge="end" aria-label="delete" onClick={() => handleClickRemove('removeCate', l)}>
                        <DeleteIcon color="error" />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </div>
                  {l.subMenu.map(s => (
                    <div className={clsx(classes.menuRow, classes.subMenu)} key={s.subMenuNo}
                      onClick={() => handleOnSelectSubMenu(s.actionMenu)}>

                      <div>
                        {s.subMenuName}
                      </div>
                      <ListItemSecondaryAction>
                        <IconButton size="medium" edge="end" aria-label="add" onClick={() => handleClickOpen('addAction', '', s)}>
                          <AddIcon color="primary" />
                        </IconButton>
                        <IconButton size="medium" edge="end" aria-label="edit" onClick={() => handleClickOpen('editSub', s.subMenuName, s)}>
                          <EditIcon color="primary" />
                        </IconButton>
                        <IconButton size="medium" edge="end" aria-label="delete" onClick={() => handleClickRemove('removeSub', s)}>
                          <DeleteIcon color="error" />
                        </IconButton>
                      </ListItemSecondaryAction>

                    </div>

                  ))}

                </div>
              ))

            }

            <div>
              <div className={classes.menuRow} style={{ color: '#1094d8' }}>

                <div onClick={() => handleClickOpen('addCate', '', null)}>
                  Add New Menu
                </div>

              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <h4>Action</h4>

          <List>
            {
              state.actions.map((row, index) => (
                <ListItem key={index} className={classes.listItem}>
                  <ListItemText className={classes.listItemText}
                    primary={`(${row.actionNo}) ${row.actionName}`}
                  />
                  <ListItemSecondaryAction>

                    <IconButton size="medium" edge="end" aria-label="edit" onClick={() => handleClickOpen('editAction', row.actionName, row)}>
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton size="medium" edge="end" aria-label="delete" onClick={() => handleClickRemove('removeAction', row)}>
                      <DeleteIcon color="error" />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>


              ))
            }
          </List>
        </Grid>

      </Grid >
    </Paper >
  );
}

export default ManageActionPage;
